export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_36-74b2ece27651ea86ed9dce8eb75d3221.jpg";